<div class="inline-loading d-flex w-100 h-100" [ngClass]="{
    'overlay-loading': overlay,
    'inline-loading' : !overlay,
    'small' : isSmall
}"
    *ngIf="showLoading">
    <div class="d-flex flex-column w-100 text-center align-self-center panel-contente">
        <div class="lds-ripple mx-auto">
            <div></div>
            <div></div>
        </div>
        <div *ngIf="!hideText" class="loading-message">{{'public.load.loadingMessage' | translate}}</div>
    </div>
</div>